import addComponentLoader, { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const componentMapping =  {
  eventForm: defineAsyncComponent(() => importWithRetry(() => import('./form')))
}

addComponentLoader(componentMapping, {}, () => importWithRetry(() => import('./store')))
